import { Box, Grid, Stack, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

export interface AmountSummaryItem {
  label: string | React.ReactNode;
  value: number | string;
  valueColor?: string;
  showDivider?: boolean;
}

export interface AmountSummarySectionProps {
  items: AmountSummaryItem[];
  currency?: string;
  formatMoney?: (value: number) => string;
  sx?: SxProps<Theme>;
}

const AmountSummarySection: React.FC<AmountSummarySectionProps> = ({
  items,
  currency = 'CLP',
  formatMoney,
  sx,
}) => {
  const formatValue = (value: number | string): string => {
    if (typeof value === 'number') {
      return formatMoney ? formatMoney(value) : value.toString();
    }
    return value;
  };

  return (
    <Box
      sx={{
        backgroundColor: 'grey.50',
        p: 1.5,
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'grey.200',
        ...sx,
      }}
    >
      <Grid container spacing={1}>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <Grid item xs={12}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                {typeof item.label === 'string' ? (
                  <Typography variant="caption" color="text.secondary">
                    {item.label}
                  </Typography>
                ) : (
                  <Box>{item.label}</Box>
                )}
                <Typography
                  variant="caption"
                  fontWeight={600}
                  color={item.valueColor || 'text.primary'}
                >
                  {formatValue(item.value)} {currency}
                </Typography>
              </Stack>
            </Grid>
            {item.showDivider && index < items.length - 1 && (
              <Grid item xs={12}>
                <Box
                  sx={{
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    my: 0.5,
                  }}
                />
              </Grid>
            )}
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  );
};

export default AmountSummarySection;
